import styled from 'styled-components';

export const HeaderContainer = styled.div`
  width: 100%;
  height: 88px;

  display: flex;
  position: relative;

  align-items: center;
  justify-content: space-between;

  padding: 0 24px;
  background-color: ${({ theme }) => theme.colors.greys.lightest};
  border-bottom: 1px solid ${({ theme }) => theme.colors.greys.light};
`;

export const LeftSideContainer = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  gap: 24px;
`;

export const RightSideContainer = styled.div`
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
`;

export const HeaderInfosContainer = styled.div`
  height: 100%;

  display: flex;
  align-items: start;
  justify-content: center;
  flex-direction: column;

  background-color: ${(props) => props.theme.colors.greys.lightest};
`;

export const Title = styled.div`
  color: ${(props) => props.theme.colors.greys.darkest};
  font: ${(props) => props.theme.fonts.h3Bold700};
`;

export const Subtitle = styled.div`
  color: ${(props) => props.theme.colors.greys.darker};
  font: ${(props) => props.theme.fonts?.textSmallHeight14};
`;

export const DropdownContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
